import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getPresentationById, loadPresentationHtml } from "./presentationsCatalog";

const PresentationViewer = () => {
  const { id } = useParams();
  const presentation = getPresentationById(id);
  const [html, setHtml] = useState(null);
  const [frameSrc, setFrameSrc] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!presentation?.contentModule) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    setError(false);
    loadPresentationHtml(presentation.contentModule)
      .then((body) => {
        if (cancelled) return;
        if (!body) {
          setError(true);
          setHtml(null);
        } else {
          setHtml(body);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setHtml(null);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [presentation]);

  // blob: evita srcDoc (em alguns browsers o CSS inline falha e sobra só o fundo preto do iframe)
  useEffect(() => {
    if (!html) {
      setFrameSrc(null);
      return undefined;
    }
    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    setFrameSrc(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [html]);

  const openInNewTab = () => {
    if (!frameSrc) return;
    window.open(frameSrc, "_blank", "noopener,noreferrer");
  };

  if (!presentation) {
    return (
      <div className="p-6">
        <p className="text-orange-100 mb-4">Apresentação não encontrada.</p>
        <Link to="/manafix/presentations" className="text-[#d59106] hover:underline">
          ← Voltar à lista
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[calc(100vh-8rem)] min-h-[480px]">
      <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-[#b47c06]/50">
        <div className="min-w-0">
          <Link to="/manafix/presentations" className="text-xs text-[#d59106] hover:underline">
            ← Apresentações
          </Link>
          <h1 className="text-sm sm:text-base text-orange-100 truncate">{presentation.title}</h1>
        </div>
        <button
          type="button"
          onClick={openInNewTab}
          disabled={!frameSrc}
          className="shrink-0 text-xs px-2 py-1 border border-[#d59106]/70 rounded text-[#d59106] hover:bg-[#d59106]/20 disabled:opacity-40"
        >
          Nova aba
        </button>
      </div>
      {loading ? (
        <p className="p-4 text-orange-100/70 text-sm">Carregando…</p>
      ) : null}
      {error ? (
        <p className="p-4 text-red-300 text-sm">Não foi possível carregar a apresentação.</p>
      ) : null}
      {frameSrc ? (
        <iframe
          title={presentation.title}
          src={frameSrc}
          className="flex-1 min-h-0 w-full border-0 bg-[#111111]"
          allow="fullscreen"
        />
      ) : null}
    </div>
  );
};

export default PresentationViewer;
